//var showConfirm = false;
var showConfirm = true;
var confirmed = false
$(document).ready(function () {
    console.log('Ready')
    if (showConfirm) {
        $('#modal-confirm').modal({
            show: true,
            backdrop:'static'
        })
        
    }
    $('.js-btn-confirm').click(function(e){
        confirmed = true
    })
    $('.js-no-confirm').click(function(e){
        window.history.back()
    })
})